// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__LFKUB","top":"styles_top__RHiEW"};